import React, { Component, createRef} from "react";
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import { Modal } from 'bootstrap';
import config from "../config";
import Login from "./Login";
import MainHeader from "../component/Header/MainHeader";
import DataTableGrid from "../component/dataTable";
import pdata from "../data.json";
import filterData from "../filter.json";
import * as XLSX from "xlsx";
import { ulid } from 'ulid';
import moment from 'moment';
import axios from 'axios';
import DataTable from "react-data-table-component";
import { DebounceInput } from 'react-debounce-input';

import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
ModuleRegistry.registerModules([AllCommunityModule]);

class AopaCode extends Component {

    constructor(props) {
        super(props);
        this.state = {
			userGuid:localStorage.getItem('user_id'),
			CreatedBy:localStorage.getItem('username'),
			role:localStorage.getItem('role'),
			policyData:pdata['policyData'],
			showUpdatePolicy:false,
			showUpdateImage:false,
			showHide:false,
			showHideCode:false,
			isHomePage:true,
			userPage1:false,
			userPage2:false,
			editCompany:false,
			editUser:false,
			fData:filterData,
			LCode:'',
			dataSetVersions:[],
			LCodeDetails:[],
			HcpcsDetails:[],
			HcpcsDetails1:[],
			HcpcsDetails2:[],
			duplicateCodes:[],
			
			selectedSetName:'',
			dataSets:[],
			dataSets2:[],
			setObjectOriginal:[],
			setObject:[],
			editRow:[],
			combineData:[],
			combineAllData:[],
			showDataSets:false,
			showCombinedDataTable:false,
			currentPage: 1,
			perPage: 10,
			searchValue: "",
			uploadMode: "new",
			highlightValue: "",
			codeFilter: "all",
			codeFilter2: "all",
			DataSetNote: "",
			selectedRow: null,
			
		}
		this.fileInputRef = createRef();
		this.fileInputRefMulti = createRef();
    }
	
	componentDidMount() {
		 this.loadScript();
		 this.getCombineDataSet();
	}
	
	/* handleCodeFilter = (value) => {
		
		let combineAllData = this.state.combineAllData;
		console.log('combineAllData->',combineAllData);
		console.log('value->',value);
		let combined = [];
		combineAllData.forEach((dataSet) => {
			const rows = dataSet.DataSetRows || [];

			rows.forEach((row, index) => {
				const shouldInclude =
					value === "all" ||
					(value === "hidden" &&
						row.CodeStatus === "Inactive") ||
					(value === "nonHidden" &&
						row.CodeStatus !== "Inactive");

				if (shouldInclude) {
					if (!combined[index]) {
						combined[index] = {};
					}

					let newObj = combined[index];

					Object.keys(row).forEach((key) => {
						if (!(key in newObj) && key !== 'updated_at') {
							newObj[key] = row[key];
						}
					});
					combined[index] = newObj;
				}
			});
		});
		console.log('combined->',combined);
		this.setState({codeFilter:value,combineData:combined.filter(item => item)});
	}; */
	
	handleCodeFilter = (value) => {
		const { combineAllData } = this.state;
		const combined = combineAllData.filter((row) => {
			return (
				value === "all" ||
				(value === "hidden" && row.CodeStatus === "Inactive") ||
				(value === "nonHidden" && row.CodeStatus !== "Inactive")
			);
		});

		this.setState({
			codeFilter: value,
			combineData: combined,
		});
	};
	
	handleCodeFilter2 = (value) => {
		/* const { combineAllData } = this.state;
		const combined = combineAllData.filter((row) => {
			return (
				value === "all" ||
				(value === "hidden" && row.CodeStatus === "Inactive") ||
				(value === "nonHidden" && row.CodeStatus !== "Inactive")
			);
		}); */

		this.setState({
			codeFilter2: value,
			//combineData: combined,
		});
	};
	
	loadScript() {
		$(function() {
		  $('.js-menu-toggle').click(function(e) {
			var $this = $(this);
			if ( $('#wrapper').hasClass('toggled') ) {
				$('#wrapper').removeClass('toggled');
				$('#wrapper').addClass('full-width');
				$this.removeClass('active');
			} else {
				$('#wrapper').addClass('toggled');
				$('#wrapper').removeClass('full-width');				
				$this.addClass('active');
			}
			e.preventDefault();
		  });
		});
	}
	
	getValue=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		this.setState({[event.target.name]:event.target.value});
		if(name == 'adminUserOption' && value == 'manageDataSets'){
			this.getDataSets();
			this.setState({showDataSets:true});
		}
		
		if(name == 'userData' && value == 'updatePolicy'){
			//console.log('policyData->',pdata);
			this.setState({showUpdatePolicy:true,isHomePage:false,showUpdateImage:false,userPage1:false,userPage2:false,userPage:'',selectedSetName:''});
		} else if(name == 'userData' && value == 'updateImage'){
			this.setState({showUpdateImage:true,showUpdatePolicy:false,isHomePage:false,userPage1:false,userPage2:false,userPage:'',selectedSetName:''});
		}
		
		if(name == 'LCode' && value != ''){
			this.state.combineData.map((val, i) => {
				//console.log('policyData->',val);
				if(val['HCPCS'] == value){	
					this.setState({LCodeDetails:val});
				}
			})
		}
		
		if(name == 'HcpcsCode' && value != ''){
			this.state.combineData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails:val,showCombinedDataTable:false});
				}
			})
		}
		
		if(name == 'HcpcsCode1' && value != ''){
			this.state.combineData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails1:val,showCombinedDataTable:false});
				}
			})
		}
		
		if(name == 'HcpcsCode2' && value != ''){
			this.state.combineData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails2:val,showCombinedDataTable:false});
				}
			})
		}
		
		if ((name === 'LCode' || name === 'HcpcsCode' || name === 'HcpcsCode1' || name === 'HcpcsCode2') && value !== '') {
			const ApiUrl = config.aopaApiUrl;
			this.setState({selectedSetName:''});
			axios.get(`${ApiUrl}/code-images/${value}`)
				.then(res => {
					if (res.data.success) {

						const mainImg = {
							name: `${value}.jpg`,
							url: `${ApiUrl}/images/${value}.jpg`
						};

						const images = [mainImg, ...res.data.images];

						this.setState({
							[value]: images
						});
					}
				});
		}
		
		if($("input[name='Rural']").prop("checked") == true){
			this.setState({Rural:true});
		}
		
		if($("input[name='Rural']").prop("checked") == false){
			this.setState({Rural:false});
		}
		
		if(name == 'Rural'){
			this.setState({policyLocation:''});
		}
		
		if(name == 'userPage' && value == 'byHcpcs'){
			this.setState({userPage1:true,userPage2:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
		}
		
		if(name == 'userPage' && value == 'compare'){
			this.setState({userPage2:true,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
		}
	}
	
	viewCombineDataSet = () => {
		
		this.getCombineDataSet();
		
		this.setState({
			showCombinedDataTable: true,
			isHomePage: false,
		});
	}
	
	getCombineDataSet = () => {
		const ApiUrl = config.aopaApiUrl;
		const url = ApiUrl + 'data-sets-v2';
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			
			if (dataSets) {
				let combined = [];
				let modifiedDates = [];
				dataSets.forEach((dataSet) => {
					//console.log('dataSet->',dataSet);
					let rows = dataSet.DataSetRows || [];
					rows.forEach((row, index) => {
						if (!combined[index]) {
							combined[index] = {};
						}
						let newObj = combined[index];
						// Add keys in order (only if not already present)
						Object.keys(row).forEach((key) => {
							if (!(key in newObj) && key != 'updated_at') {
								newObj[key] = row[key];
							}
							/*  else {
								newObj[key] = row[key]; // overwrite but keep position
							} */
						});
						combined[index] = newObj;
					});
					modifiedDates.push(dataSet.ModifiedDate);
				});

				const latest = modifiedDates.length
					? new Date(
						Math.max(
							...modifiedDates.map(
								d => new Date(d.replace(' ', 'T'))
							)
						)
					)
					: null;

				this.setState({
					combineData: combined.filter(item => item),
					combineAllData: combined.filter(item => item),
					combinedLastDate: latest,
					selectedSetName: []
				});

				$("#dataSet").val('');
			}
		})
		.catch(error => {
			console.error('Error loading datasets:', error);
		});
	};
	
	/* getCombineDataSet = () => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-sets-v2';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				let combined = [];
				let modifiedDates = [];
				dataSets.forEach((dataSet) => {
					//console.log('dataSet->',dataSet);
					let rows = dataSet.DataSetRows || [];
					rows.forEach((row, index) => {
						if(row.CodeStatus != 'Inactive' || this.state.showHide == true){
							if (!combined[index]) {
								combined[index] = {};
							}
							let newObj = combined[index];
							// Add keys in order (only if not already present)
							Object.keys(row).forEach((key) => {
								if (!(key in newObj) && key != 'updated_at') {
									newObj[key] = row[key];
								}
								
							});
						
						
						
							console.log('newObj->',newObj.CodeStatus);
							combined[index] = newObj;
						}
					});
					modifiedDates.push(dataSet.ModifiedDate);
				});
				
				const latest = new Date(
				  Math.max(...modifiedDates.map(d => new Date(d.replace(' ', 'T'))))
				);
				
				this.setState({showCombinedDataTable:true,combineData:combined,isHomePage:false, combinedLastDate:latest,selectedSetName:[]});
				$("#dataSet").val('');
			}
		});
		
		//console.log('modifiedDate Rows:', modifiedDate);
	}; */
	
	builderOption = () => {
		
	}
	
	/* handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		let fileName = file.name;
		fileName = fileName.split("_")[0];
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
			  defval: ""
			}).map(({ __rowNum__, ...rest }) => rest);

			console.log("ExcelData:", jsonData);
			let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			let uld = ulid();
			let fieldData = {
				"DataSetName": fileName,
				"DataSetGuid":uld,
				"Description":'',
				"CreatedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"ModifiedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"CreatedBy": 'admin',
				"DataSetRows": jsonData,
			}
			this.storeDataSet(fieldData);
			//this.setState({ excelData: jsonData });
		};
		reader.readAsArrayBuffer(file);
	}; */
	
	handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();

		const sanitizeKey = (key) => {
			return key
				.replace(/\s*\(\s*/g, "(")
				.replace(/\s*\)\s*/g, ")")
				.replace(/[^a-zA-Z0-9() ]/g, "")
				.trim()
				.replace(/\s+/g, "");
		};

		const fileName = file.name.split("_")[0];

		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];

			// Read worksheet as arrays to preserve column order
			const sheet = XLSX.utils.sheet_to_json(worksheet, {
				header: 1,
				defval: "",
				blankrows: false
			});

			const headers = sheet[0]
				.filter(h => h !== undefined && h !== null && h.toString().trim() !== "")
				.map(h => sanitizeKey(h.toString()));

			const jsonData = [];

			for (let i = 1; i < sheet.length; i++) {
				const row = sheet[i];

				// Skip completely blank rows
				if (!row || row.every(cell => cell === "" || cell === undefined || cell === null)) {
					continue;
				}

				const newRow = {};

				headers.forEach((header, index) => {
					newRow[header] = row[index] ?? "";
				});

				newRow.updated_at = moment().format("YYYY-MM-DD HH:mm:ss");

				jsonData.push(newRow);
			}

			const currentDate = new Date()
				.toLocaleString("en-US", { timeZone: "America/New_York" })
				.replace(",", "");

			const fieldData = {
				DataSetName: fileName,
				DataSetGuid: ulid(),
				Description: "",
				CreatedDate: moment(currentDate).format("YYYY-MM-DD HH:mm:ss"),
				ModifiedDate: moment(currentDate).format("YYYY-MM-DD HH:mm:ss"),
				CreatedBy: "admin",
				DataSetRows: jsonData
			};

			this.storeDataSet(fieldData);

			if (this.fileInput) {
				this.fileInput.value = "";
			}
		};

		reader.readAsArrayBuffer(file);
	};
	
	storeDataSet = (data) => {
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'add-data-set';
		console.log("JSON Data:", data);
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				let setObject = this.state.setObject;
				if (setObject && setObject.DataSetGuid) {
					this.loadDataSet2(setObject.DataSetGuid);
				}
				alert(res.message);
				this.getDataSets();
			}
		}).catch(error => {
			if (error.response) {
				alert(error.response.data.message);

				if (error.response.data.duplicates) {
					this.setState({
						showDuplicateModal: true,
						duplicateCodes: error.response.data.duplicates
					});
					
					const modal = new Modal(document.getElementById('showDuplicateModal'));
					modal.show();
				}
			}
		});
	};
	
	handleFileUpload2 = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();

		const sanitizeKey = (key) => {
			return key
				.replace(/\s*\(\s*/g, "(")
				.replace(/\s*\)\s*/g, ")")
				.replace(/[^a-zA-Z0-9() ]/g, "")
				.trim()
				.replace(/\s+/g, "");
		};

		const fileName = file.name.split("_")[0];

		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];

			// Read worksheet as arrays to preserve column order
			const sheet = XLSX.utils.sheet_to_json(worksheet, {
				header: 1,
				defval: "",
				blankrows: false
			});

			const headers = sheet[0]
				.filter(h => h !== undefined && h !== null && h.toString().trim() !== "")
				.map(h => sanitizeKey(h.toString()));

			const jsonData = [];

			for (let i = 1; i < sheet.length; i++) {
				const row = sheet[i];

				// Skip completely blank rows
				if (!row || row.every(cell => cell === "" || cell === undefined || cell === null)) {
					continue;
				}

				const newRow = {};

				headers.forEach((header, index) => {
					newRow[header] = row[index] ?? "";
				});

				newRow.updated_at = moment().format("YYYY-MM-DD HH:mm:ss");

				jsonData.push(newRow);
			}

			const currentDate = new Date()
				.toLocaleString("en-US", { timeZone: "America/New_York" })
				.replace(",", "");

			let fieldData = {
			  DataSetGuid: this.state.selectedSetGuid,
			  DataSetName: this.state.selectedSetName,
			  CreatedDate: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
			  ModifiedDate: moment(	).format('YYYY-MM-DD HH:mm:ss'),
			  DataSetRows: jsonData,
			};
			
			this.UpdateDataSet(fieldData);
			
			if (this.fileInput2) {
				this.fileInput2.value = "";
			}
		};

		reader.readAsArrayBuffer(file);
	};
	
	handleFileUpload42 = (event) => {
		const file = event.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		const sanitizeKey = (key) => {
			return key
			.replace(/[^a-zA-Z0-9]/g, '')
			.trim();
		};

		let fileName = file.name;
		fileName = fileName.split("_")[0];
		
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
				defval: ""
			}).map((row) => {
				const newRow = {};
				Object.keys(row).forEach((key) => {
					if (key === "__rowNum__") return;
					const cleanKey = sanitizeKey(key);
					newRow[cleanKey] = row[key];
				});
				newRow.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
				return newRow;
			});
			let currentDate = new Date()
			  .toLocaleString("en-US", { timeZone: "America/New_York" })
			  .replace(",", "");

			//let uld = ulid();

			let fieldData = {
			  DataSetGuid: this.state.selectedSetGuid,
			  DataSetName: this.state.selectedSetName,
			  CreatedDate: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
			  ModifiedDate: moment(	).format('YYYY-MM-DD HH:mm:ss'),
			  DataSetRows: jsonData,
			};
			
			this.UpdateDataSet(fieldData);
			if (this.fileInput2) {
				this.fileInput2.value = "";
			}
		};

		reader.readAsArrayBuffer(file);
	};
	
	getDataSets = () => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-sets';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				this.setState({dataSets:dataSets});
			}else{
				this.setState({dataSets:[]});
			}
		});
	}
	
	getDataSetsV2 = () => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-sets-v2';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				this.setState({dataSets2:dataSets});
			}else{
				this.setState({dataSets2:[]});
			}
		});
	}
	
	loadDataSet = (event) => {
		let setName = event.target.options[event.target.selectedIndex].text;
		let setGuid = event.target.value;
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-set/'+setGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			//console.log('data->',data);
			this.setState({selectedSetGuid:setGuid,setObjectOriginal:data,setObject:data,selectedSetName:setName,isHomePage:false,showCombinedDataTable:false});
			this.getDataSetVersions(setGuid);
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getDataSetVersions = (setGuid) => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-set-versions/'+setGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			//console.log('data->',data);
			this.setState({dataSetVersions:data});
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	loadDataSet2 = (setGuid) => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'data-set/'+setGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			this.setState({setObject:data,selectedSetName:data.DataSetName});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	UpdateDataSet = (data) => {
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'update-data-set';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				let setObject = this.state.setObject;
				if (setObject && setObject.DataSetGuid) {
					this.loadDataSet2(setObject.DataSetGuid);
				}
				alert(res.message);
				this.getDataSets();
			}else{
				alert('Wrong Data Set!');
			}
			const modalEl = document.getElementById('editRowPopup');
			const modal = Modal.getInstance(modalEl); // get the existing instance
			if(modal){
				modal.hide();
			}
		}).catch(error => {
			if (error.response) {
				alert(error.response.data.message);

				if (error.response.data.duplicates) {
					this.setState({
						showDuplicateModal: true,
						duplicateCodes: error.response.data.duplicates
					});
					
					const modal = new Modal(document.getElementById('showDuplicateModal'));
					modal.show();
				}
			}
		});
	};

	uploadDataSet = () => {
		const modal = new Modal(document.getElementById('uploadSetPopup'));
		modal.show();
	};
	
	uploadCodeData = () => {
		const modal = new Modal(document.getElementById('uploadCodeDataPopup'));
		modal.show();
	};
	
	replaceDataSet = () => {
		const modal = new Modal(document.getElementById('replaceSetPopup'));
		modal.show();
	};
	
	uploadDataSet2 = () => {
		this.fileInput.click();
	};
	
	uploadDataSet3 = () => {
		this.fileInput2.click();
	};
	
	uploadDataSet4 = () => {
		this.fileInput4.click();
	};
		
	handleButtonClick = () => {
		this.fileInputRef.current.click();
	};
	
	handleFileChange = async (event) => {
		const file = event.target.files[0];
		if (!file) {
			return;
		}
		const formData = new FormData();
		formData.append("image", file);
		formData.append("code", this.state.LCode);
		
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'upload-image';

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData
			});

			const result = await response.json();

			if (result.success) {
				alert("Image uploaded successfully!");
				const localUrl = URL.createObjectURL(file);
				this.setState({[this.state.LCode]: localUrl});
				console.log(result.path);
			}
		} catch (error) {
			console.error("Upload failed:", error);
		}
	};
	
	handleButtonClickMulti = () => {
		this.fileInputRefMulti.current.click();
	};
	
	handleMultipleImages = async (e) => {
		const files = e.target.files;

		if (!files.length) return;

		const formData = new FormData();

		for (let i = 0; i < files.length; i++) {
			formData.append('images[]', files[i]);
		}

		formData.append("code", this.state.LCode);
		
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'upload-multiple-images';

		try {
			const response = await fetch(url, {
				method: 'POST',
				body: formData
			});

			const result = await response.json();
			if (result.success) {
				alert("Images uploaded successfully!");
			}
			
		} catch (error) {
			console.log(error);
		}
	}
	
	handleButtonClick2 = () => {
		this.setState({editCompany:true,editUser:false,userPage2:false,userPage1:false,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
	};
	
	handleButtonClick3 = () => {
		this.setState({editUser:true,editCompany:false,userPage1:false,userPage2:false,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
	};
	
	handleEdit = (row) => {
		//console.log("Edit row:", row);
		this.setState({editRow:row});
		const modal = new Modal(document.getElementById('editRowPopup'));
		modal.show();
	};
	
	handleShowDescription = (key) => {
		const setObject = this.state.setObject;
		let parmKey = key.replace(/([A-Z])/g, " $1").trim();
		let parms = 'HDes'+key;
		this.setState({headerName:parmKey,headerDescription:setObject[parms]});
		const modal = new Modal(document.getElementById('DataSetsHeaderDetails'));
		modal.show();
	}
	
	getColumns = () => {
		const setObject = this.state.setObject;
		let dataSetRows = setObject.DataSetRows ? setObject.DataSetRows : [];

		if (!dataSetRows || dataSetRows.length === 0) return [];

		// Get keys and ensure HCPCS is always the first column
		const keys = Object.keys(dataSetRows[0])
			.filter((key) => key !== "updated_at" && key !== "CodeStatus");

		const orderedKeys = [
			...keys.filter((key) => key.toLowerCase() === "hcpcs"),
			...keys.filter((key) => key.toLowerCase() === "ceiling"),
			...keys.filter((key) => key.toLowerCase() === "floor"),
			...keys.filter(
				(key) =>
					key.toLowerCase() !== "hcpcs" &&
					key.toLowerCase() !== "ceiling" &&
					key.toLowerCase() !== "floor"
			),
		];

		const dynamicColumns = orderedKeys.map((key) => ({
			name: (
				<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
					<span>{key.replace(/([A-Z])/g, " $1").trim()}</span>
					{key.toLowerCase() !== "hcpcs" && (
						<button
							type="button"
							onClick={(e) => {
								e.stopPropagation();
								this.handleShowDescription(key);
							}}
							style={{
								border: "none",
								background: "transparent",
								cursor: "pointer",
								color: "#007bff",
							}}
						>
							<i className="fa fa-info-circle" aria-hidden="true"></i>
						</button>
					)}
				</div>
			),
			selector: (row) => row[key],
			sortable: true,
			wrap: false,
			cell: (row) => (
				<div
					title={row[key]}
					style={{
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						minWidth: "150px",
						maxWidth: "400px",
						cursor: "pointer",
					}}
				>
					{row[key]}
				</div>
			),
		}));

		let actionColumn2 = {
			name: "Actions",
			cell: (row) => (
				<button className="btn" onClick={() => this.handleEdit(row)}>
					<i className="fa fa-edit"></i>
				</button>
			),
			ignoreRowClick: true,
			allowOverflow: false,
			button: true,
		};

		let actionColumn = {
			name: (
				<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
					<span>History</span>
					<button
						type="button"
						onClick={(e) => {
							e.stopPropagation();
							this.handleShowDescription("History");
						}}
						style={{
							border: "none",
							background: "transparent",
							cursor: "pointer",
							color: "#007bff",
						}}
					>
						<i className="fa fa-info-circle" aria-hidden="true"></i>
					</button>
				</div>
			),
			selector: (row) => new Date(row.updated_at),
			sortable: true,
			cell: (row) => (
				<span>{moment(row.updated_at).format("MM-DD-YYYY h:mm A")}</span>
			),
			ignoreRowClick: true,
			allowOverflow: false,
			wrap: false,
			minWidth: "200px",
			maxWidth: "200px",
		};

		if (this.state.selectedVersion) {
			actionColumn2 = null;
		}

		return actionColumn2
			? [...dynamicColumns, actionColumn, actionColumn2]
			: [...dynamicColumns, actionColumn];
	};
	
	/* getColumns = () => {
		const setObject = this.state.setObject;
		let dataSetRows = 	setObject.DataSetRows ? setObject.DataSetRows : [];
		//console.log('dataSetRows->',dataSetRows);
		if (!dataSetRows || dataSetRows.length === 0) return [];

		const dynamicColumns = Object.keys(dataSetRows[0])
		  .filter((key) => key !== "updated_at" && key !== 'CodeStatus')
		  .map((key) => ({
			name: (
			  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
				<span>{key.replace(/([A-Z])/g, " $1").trim()}</span>
				{key.toLowerCase() !== "hcpcs" && (
				<button
				  type="button"
				  onClick={(e) => {
					e.stopPropagation(); // prevents column sort
					this.handleShowDescription(key);
				  }}
				  style={{
					border: "none",
					background: "transparent",
					cursor: "pointer",
					color: "#007bff"
				  }}
				>
				 <i className="fa fa-info-circle" aria-hidden="true"></i>
				</button>
				)}
			  </div>
			),
			selector: (row) => row[key],
			sortable: true,
			wrap: false,
			cell: (row) => (
			  <div
				title={row[key]}
				style={{
				  whiteSpace: "nowrap",
				  overflow: "hidden",
				  textOverflow: "ellipsis",
				  maxWidth: "400px",
				  cursor: "pointer",
				}}
			  >
				{row[key]} 
			  </div>
			),
		}));

		let actionColumn2 = {
		  name: "Actions",
		  cell: (row) => (
			<button className="btn" onClick={() => this.handleEdit(row)}>
			 <i className="fa fa-edit"></i>
			</button>
		  ),
		  ignoreRowClick: true,
		  allowOverflow: false,
		  button: true,
		  
		};
		
		let actionColumn = {
		  name: "History",
			name: (
			  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
				<span>History</span>
				<button
				  type="button"
				  onClick={(e) => {
					e.stopPropagation(); // prevents column sort
					this.handleShowDescription('History');
				  }}
				  style={{
					border: "none",
					background: "transparent",
					cursor: "pointer",
					color: "#007bff"
				  }}
				>
				 <i className="fa fa-info-circle" aria-hidden="true"></i>
				</button>
				
			  </div>
			),
		  selector: (row) => new Date(row.updated_at),
		  sortable: true,
		  cell: (row) => (
			<span>
			  {moment(row.updated_at).format('MM-DD-YYYY h:mm A')}
			</span>
		  ),
		  ignoreRowClick: true,
		  allowOverflow: false,
		  wrap: false,
		  minWidth: "200px", 
		  maxWidth: "200px", 
		};
		
		if(this.state.selectedVersion){
			actionColumn2 = null;
		}
		
		return actionColumn2
		  ? [...dynamicColumns, actionColumn, actionColumn2]
		  : [...dynamicColumns, actionColumn];
	}; */
	
	/* getColumns2 = () => {
		const setObject = this.state.combineData;
		let dataSetRows = 	setObject ? setObject : [];
		if (!dataSetRows || dataSetRows.length === 0) return [];
		const dynamicColumns = Object.keys(dataSetRows[0])
		  .filter((key) => key !== "updated_at")
		  .map((key) => ({
			name: key.replace(/([A-Z])/g, " $1").trim(),
			selector: (row) => row[key],
			sortable: true,
			wrap: false,
			cell: (row) => (
			  <div
				title={row[key]}
				style={{
				  whiteSpace: "nowrap",
				  overflow: "hidden",
				  textOverflow: "ellipsis",
				  maxWidth: "400px",
				  cursor: "pointer",
				}}
			  >
				{row[key]}
			  </div>
			),
		}));

		return [...dynamicColumns];
	}; */
	
	getColumns2 = () => {
		const setObject = this.state.combineData;
		let dataSetRows = setObject ? setObject : [];
		if (!dataSetRows || dataSetRows.length === 0) return [];

		// Generate dynamic columns, excluding "updated_at"
		const dynamicColumns = Object.keys(dataSetRows[0])
			.filter((key) => key !== "updated_at" && key !== 'CodeStatus')
			.map((key) => ({
				name: key.replace(/([A-Z])/g, " $1").trim(),
				selector: (row) => row[key],
				sortable: true,
				wrap: false,
				cell: (row) => (
					<div
						title={row[key]}
						style={{
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							maxWidth: "400px",
							cursor: "pointer",
						}}
					>
						{row[key]}
					</div>
				),
		}));
		
		if(this.state.showColumn){
			const customColumn = {
				name: "Hide/Show",
				sortable: false,
				wrap: false,
				cell: (row) => {
					// Determine which icon to show
					const icon = row.CodeStatus === 'Inactive' 
						? <i className="fa fa-eye-slash" aria-hidden="true"></i> 
						: <i className="fa fa-eye" aria-hidden="true"></i>;
					return (
						<button className="btn" onClick={() => this.handleHideShow(row.HCPCS)}>
							{icon}
						</button>
					);
				},
			};

			dynamicColumns.splice(1, 0, customColumn);
		}
		
		return [...dynamicColumns];
		
	};
	
	hideShowColumn = () => {
		let showColumn = this.state.showColumn;
		if(showColumn){
			this.setState({showColumn:false});
		}else{
			this.setState({showColumn:true});
		}
	}
	
	handleHideShow = (code) => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl+'update-code-status/'+code;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			this.getCombineDataSet();
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getColumns3 = () => {
		const setObject = this.state.setObject;
		let dataSetRows = setObject.DataSetRows || [];
		if (!dataSetRows || dataSetRows.length === 0) return [];
		const dynamicColumns = Object.keys(dataSetRows[0])
		.filter((key) => key !== "updated_at" && key !== 'CodeStatus')
		.map((key) => ({
		  headerName: key.replace(/([A-Z])/g, " $1").trim(),
		  field: key,
		  resizable: true,
		  sortable: true,
		  //filter: true,
		  //flex: 1
		}));

		const historyColumn = {
			headerName: "History",
			field: "updated_at",
			//filter: true,
			pinned: "right",
			sortable: true,
			valueFormatter: (params) =>
			moment(params.value).format("MM-DD-YYYY h:mm A"),
			maxWidth: 165
		};
	  
		const ActionButton = (props) => {
			return (
				<button
				  className="btn"
				  onClick={() => props.context.componentParent.handleEdit(props.data)}
				>
				  <i className="fa fa-edit"></i>
				</button>
			);
		};	

		const actionColumn = {
			headerName: "Actions",
			cellRenderer: !this.state.selectedVersion ? ActionButton : '',
			pinned: "right",			  
			width: 80
		};
		
		//console.log('dynamicColumns->',dynamicColumns);
		//console.log('historyColumn->',historyColumn);
		//console.log('actionColumn->',actionColumn);

		return [...dynamicColumns, historyColumn, actionColumn];
	};
	
	handleInputChange = (e) => {
		this.setState({ searchValue: e.target.value });
	};

	/* goToRow = (value) => {
		const setObject = this.state.setObject;
		let dataSetRows = 	setObject.DataSetRows ? setObject.DataSetRows : [];
		const { perPage, searchValue } = this.state;
		const index = dataSetRows.findIndex(
		(row) => row.HCPCS === searchValue || row.HCPCS?.includes(searchValue)
		);

		if (index === -1) {
		alert("Value not found");
		return;
		}
		const page = Math.floor(index / perPage) + 1;
		
		console.log('index->',index);
		console.log('page->',page);
		this.setState({currentPage:page, highlightValue:searchValue});
	}; */
	
	goToRow = () => {
		const dataSetRows = this.state.setObject.DataSetRows || this.state.combineData || [];
		const { perPage, searchValue } = this.state;
		const index = dataSetRows.findIndex(
		(row) =>
		  row.HCPCS === searchValue ||
		  row.HCPCS?.includes(searchValue)
		);

		if (index === -1) {
		alert("Value not found");
		return;
		}
		const page = Math.floor(index / perPage) + 1;

		this.setState((prev) => ({
		currentPage: page,
		highlightValue: searchValue,
		resetPaginationToggle: !prev.resetPaginationToggle
		}));
	};
	
	clearSearch = () => {
		this.setState({ searchValue:'', highlightValue:'',currentPage:1});
	}
	
	editRowUpdate = () => {
		let data = this.state.editRow;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		if (data) {
			const updatedData = { ...data };
			Object.keys(this.state).forEach((key) => {
			  if (updatedData.hasOwnProperty(key)) {
				updatedData[key] = this.state[key];
			  }
			});

			//console.log("Updated Row:", updatedData);
			let setObject = this.state.setObject;
			let dataSetRows = setObject.DataSetRows ? setObject.DataSetRows : [];

			/* const updatedRows = dataSetRows.map((row) => {
				if (row.HCPCS === updatedData.HCPCS) {
					return updatedData; // replace matched row
				}
			  return row;
			}); */
			
			const updatedRows = dataSetRows.map((row) => {
				if (row.HCPCS === updatedData.HCPCS) {
					return {
						...updatedData,
						updated_at: moment(currentDate).format('YYYY-MM-DD HH:mm:ss')
					};
				}
				return row;
			});

			//console.log("Updated Rows:", updatedRows);

			setObject.DataSetRows = updatedRows;
			
			setObject.ModifiedDate = moment(currentDate).format('YYYY-MM-DD HH:mm:ss');
			
			this.setState({setObject:setObject});
			this.UpdateDataSet(setObject);
		}
	};
	
	downloadLatestData = () => {
		let setObject = this.state.setObjectOriginal;
		const dataRows = setObject.DataSetRows || [];

		if (dataRows.length === 0) {
			alert("No data available to download!");
			return;
		}

		// Remove updated_at from each row
		const filteredRows = dataRows.map(({ updated_at, ...rest }) => rest);

		const worksheet = XLSX.utils.json_to_sheet(filteredRows);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		const dateObj = new Date(setObject.ModifiedDate);
		const month = String(dateObj.getMonth() + 1).padStart(2, "0");
		const day = String(dateObj.getDate()).padStart(2, "0");
		const year = String(dateObj.getFullYear());

		const hours = String(dateObj.getHours()).padStart(2, "0");
		const minutes = String(dateObj.getMinutes()).padStart(2, "0");
		const seconds = String(dateObj.getSeconds()).padStart(2, "0");

		const formattedDateTime = `${month}${day}${year}_${hours}${minutes}${seconds}`;

		const fileName = `${setObject.DataSetName || "Dataset"}_${formattedDateTime}.xlsx`;

		XLSX.writeFile(workbook, fileName);
	};
	
	downloadCombinedData = () => {
		let ModifiedDate = this.state.combinedLastDate;
		
		let dataRows = this.state.combineData || [];
		
		if(this.state.selectedRow){
			dataRows = [this.state.selectedRow];
		}

		if (dataRows.length === 0) {
			alert("No data available to download!");
			return;
		}
		const worksheet = XLSX.utils.json_to_sheet(dataRows);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		const dateObj = new Date(ModifiedDate);
		const month = String(dateObj.getMonth() + 1).padStart(2, "0");
		const day = String(dateObj.getDate()).padStart(2, "0");
		const year = String(dateObj.getFullYear());

		const hours = String(dateObj.getHours()).padStart(2, "0");
		const minutes = String(dateObj.getMinutes()).padStart(2, "0");
		const seconds = String(dateObj.getSeconds()).padStart(2, "0");

		const formattedDateTime = `${month}${day}${year}_${hours}${minutes}${seconds}`;
		
		const fileName = `${"CombinedDataset"}_${formattedDateTime}.xlsx`;
		XLSX.writeFile(workbook, fileName);
	};
	
	downloadCombinedDataHeader = () => {
		const dataRows = this.state.combineData || [];

		if (dataRows.length === 0) {
			alert("No data available to determine headers!");
			return;
		}

		const headers = Object.keys(dataRows[0]).filter(
			key => !["updated_at", "CodeStatus"].includes(key)
		);

		const worksheet = XLSX.utils.json_to_sheet([], {
			header: headers
		});

		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		XLSX.writeFile(workbook, "CombinedDatasetTemplate.xlsx");
	};
	
	handleEditDataSet = (setObject) => {
		this.setState({DataSetGuid:setObject.DataSetGuid, DataSetName:setObject.DataSetName, FilePrefix:setObject.FilePrefix, Description:setObject.Description, DataSetNotes:setObject.DataSetNotes});
		let that = this;
		setTimeout(function(){
			const modal = new Modal(document.getElementById('DataSetsEditDetails'));
			modal.show();
		}, 1000);
	}
	
	dataSetsDetails = () => {
		const modal = new Modal(document.getElementById('DataSetsDetails'));
		modal.show();
	};
	
	uploadDataSetDetails = () => {
		let {
		  DataSetGuid,
		  DataSetName,
		  FilePrefix,
		  Description,
		  DataSetNotes,
		  DataSetNote,
		  HDesHistory
		} = this.state;

		//let timestamp = new Date().toISOString();
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let newEntry = `${moment(currentDate).format('MM-DD-YYYY h:mm A')} - ${DataSetNote}`;
		let updatedNotes = DataSetNotes
		  ? `${DataSetNotes}\n${newEntry}`
		  : newEntry;
		
		let dynamicFields = {};

		Object.keys(this.state.setObject.DataSetRows[0]).forEach((key) => {
			if (key === "HCPCS" || key === "updated_at" || key === "__rowNum__") return null;
			dynamicFields['HDes' + key] = this.state['HDes' + key];
		});

		let rData = {
		  DataSetGuid,
		  DataSetName,
		  FilePrefix,
		  Description,
		  DataSetNotes: updatedNotes,
		  ...dynamicFields,
		  HDesHistory
		};
		console.log('rData->',rData);
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'update-details';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(rData),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				this.getDataSets();
				this.loadDataSet2(DataSetGuid);
				alert(res);
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	downloadTemplate = () => {
		let ApiUrl = config.aopaApiUrl;
		let url = ApiUrl + 'hcpcs';

		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const hcpcsCodes = response.data; 
			const data = [["HCPCS"]]; 
			hcpcsCodes.forEach(code => {
				data.push([code]); 
			});
			const ws = XLSX.utils.aoa_to_sheet(data);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Template");
			const now = new Date();
			const formattedDate = now.toLocaleString("en-US", {
				timeZone: "America/New_York",
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
				hour: "numeric",
				minute: "2-digit",
				hour12: true
			}).replace(/[\/,: ]/g, "-");

			const fileName = `HCPCS_template-${formattedDate}.xlsx`;
			XLSX.writeFile(wb, fileName);
		})
		.catch(error => {
			console.error("Error fetching HCPCS codes:", error);
		});
	};
	
	showAllCodes=()=>{
		let showHide = this.state.showHide;
		if($("input[name='showHide']").prop("checked") == true){
			this.setState({showHide:true});
		}else{
			this.setState({showHide:false});
		}
		let that = this;
		setTimeout(function(){
			that.getCombineDataSet();
		}, 1000);
	}
	
	showAllCodes2=()=>{
		let showHideCode = this.state.showHideCode;
		if($("input[name='showHideCode']").prop("checked") == true){
			this.setState({showHideCode:true});
		}else{
			this.setState({showHideCode:false});
		}
	}
	
	handleRowClick = (row) => {
		this.setState((prevState) => ({
			selectedRow:
				prevState.selectedRow &&
				prevState.selectedRow.HCPCS === row.HCPCS
					? null
					: row
		}));
	};
	
	handleNewCode = () => {
		const modal = new Modal(document.getElementById('addNewCode'));
		modal.show();
	};
	
	addNewHcpcsCode = () => {
		let NewCode = this.state.NewCode;
		if(NewCode){
			let ApiUrl = config.aopaApiUrl;
			let url = ApiUrl+'add-new-code/'+NewCode;
			let data = [];
			axios({
				method: 'GET',
				url: url,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				this.getCombineDataSet();
			}).catch(error => {
				console.log('error::', error);
			})
		}
		
		const modalEl = document.getElementById('addNewCode');
		const modal = Modal.getInstance(modalEl);
		if(modal){
			modal.hide();
		}
	}
	
	handleEditCode = () => {
		const modal = new Modal(document.getElementById('editCodePopup'));
		modal.show();
	};
	
	editCodeDataUpdate = () => {
		let data = this.state.selectedRow;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		if (data) {
			const updatedData = { ...data };
				Object.keys(this.state).forEach((key) => {
				if (updatedData.hasOwnProperty(key)) {
					updatedData[key] = this.state[key];
				}
			});
			
			let combineData = this.state.combineData;
			let dataSetRows = combineData ? combineData : [];

			const updatedRows = dataSetRows.map((row) => {
				if (row.HCPCS === updatedData.HCPCS) {
					return {
						...updatedData,
						updated_at: moment(currentDate).format('YYYY-MM-DD HH:mm:ss')
					};
				}
				return row;
			});
			
			this.storeDataSet2(updatedData);
			let that = this;
			setTimeout(function(){
				that.setState({combineData:updatedRows,selectedRow:null,selectedKeyEdit:null});
			}, 3000);
			
		}
	};
	
	storeDataSet2 = (data) => {
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'update-code-data';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			alert(res);
			const modalEl = document.getElementById('editCodePopup');
			const modal = Modal.getInstance(modalEl);
			if(modal){
				modal.hide();
			}
		}).catch(error => {
			console.log('error::', error);
		})
	};
	
	selectKeyToEdit = (event) => {
		let key = event.target.value;
		this.setState({selectedKeyEdit:key});
	}
	
	handleFileUploadRowData = (event) => {
		const file = event.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		const sanitizeKey = (key) => {
			return key
			.replace(/[^a-zA-Z0-9]/g, '')
			.trim();
		};

		let fileName = file.name;
		fileName = fileName.split("_")[0];
		
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
				defval: ""
			}).map((row) => {
				const newRow = {};
				Object.keys(row).forEach((key) => {
					if (key === "__rowNum__") return;
					const cleanKey = sanitizeKey(key);
					newRow[cleanKey] = row[key];
				});
				newRow.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
				return newRow;
			});
			let currentDate = new Date()
			  .toLocaleString("en-US", { timeZone: "America/New_York" })
			  .replace(",", "");
			//console.log('jsonData->',jsonData);
			this.UpdateRowData(jsonData);
			if (this.fileInput4) {
				this.fileInput4.value = "";
			}
		};

		reader.readAsArrayBuffer(file);
	};
	
	UpdateRowData = (data) => {
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl + 'update-row-data';

		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const res = response.data;

			if (res.success) {

				let setObject = this.state.setObject;
				if (setObject && setObject.DataSetGuid) {
					this.loadDataSet2(setObject.DataSetGuid);
				}

				this.getCombineDataSet();

				alert(res.message); // Show success message

			} else {
				alert(res.message || 'Something went wrong.');
			}

			const modalEl = document.getElementById('editRowPopup');
			const modal = Modal.getInstance(modalEl);

			if (modal) {
				modal.hide();
			}
		}).catch(error => {
			if (error.response) {
				alert(error.response.data.message);

				if (error.response.data.duplicates) {
					
					this.setState({
						showDuplicateModal: true,
						duplicateCodes: error.response.data.duplicates
					});
					
					const modal = new Modal(document.getElementById('showDuplicateModal'));
					modal.show();
				}
			}
		});
	};
	
	handleVersionChange = (e) => {
		const selectedVersion = e.target.value;
		const ApiUrl = config.aopaApiUrl;
		const setGuid = this.state.selectedSetGuid;
		let url = ApiUrl+'old-data-set/'+setGuid+'/'+selectedVersion;
		if(selectedVersion == ''){
			url = ApiUrl+'data-set/'+setGuid;
		}
		this.setState({selectedVersion: selectedVersion});
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			this.setState({setObject:data});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	revertDataSet = (version) => {
		const setObject = this.state.setObject;
		//console.log('setObject->',setObject);
		
		let aopaApiUrl = config.aopaApiUrl;
		let url = aopaApiUrl+'revert-data-set';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(setObject),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				alert(res);
				this.setState({selectedVersion:''});
				if (setObject && setObject.DataSetGuid) {
					this.loadDataSet2(setObject.DataSetGuid);
				}
				this.getDataSets();
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	render() {
		
		const {dataMode,role,policyData,isHomePage,showUpdatePolicy,showUpdateImage,LCode,HcpcsCode,HcpcsCode1,HcpcsCode2,LCodeDetails,HcpcsDetails,HcpcsDetails1,HcpcsDetails2,fData, showDataSets,dataSets,setObject,combineAllData,combineData,dataSets2,currentPage,codeFilter,codeFilter2} = this.state;
		
		console.log('setObject->',setObject);
		//console.log('HcpcsCode->',this.state[HcpcsCode]);
		/* let dataSetRows = setObject.DataSetRows ? setObject.DataSetRows : [];
		
		if (dataSetRows && this.state.showHideCode === false) {
			let filteredItems = [];
			for (let i = 0; i < dataSetRows.length; i++) {
				if (dataSetRows[i]['CodeStatus'] !== "Inactive") {  // keeping non-active
					filteredItems.push(dataSetRows[i]);
				}
			}
			dataSetRows = filteredItems;
		} */
		
		const ApiUrl = config.aopaApiUrl;
		let imagePath = ApiUrl+'/images/'+LCode+'.jpg';
		let LCodeState = this.state[LCode];

		if(LCodeState){
			imagePath = LCodeState;
		}
		
		let dataSetRows = setObject.DataSetRows || [];
		
		console.log('dataSetRows->',dataSetRows);

		switch (this.state.codeFilter2) {
			case "hidden":
				dataSetRows = dataSetRows.filter(
					row => row.CodeStatus === "Inactive"
				);
				break;
			case "nonHidden":
				dataSetRows = dataSetRows.filter(
					row => row.CodeStatus !== "Inactive"
				);
				break;

			case "all":
			default:
				// no filtering
				break;
		}
		
		/* const formatRowValues = rows =>
		  rows.map(row => {
			const newRow = {};
			Object.keys(row).forEach(key => {
			  const val = row[key];
			  const num = Number(val);

			  if (!isNaN(num) && !Number.isInteger(num)) {
				newRow[key] = num.toFixed(2);
			  } else {
				newRow[key] = val; // keep integers & others as is
			  }
			});
			return newRow;
		}); */
		
		const formatRowValues = rows =>
			rows.map(row => {
			const newRow = {};
			Object.keys(row).forEach(key => {
			  const val = row[key];
			  const num = Number(val);

			  if (!isNaN(num) && !Number.isInteger(num)) {
				newRow[key] = Number(num.toFixed(2));
			  } else {
				newRow[key] = val;
			  }
			});
			return newRow;
		});
		
		
		dataSetRows = formatRowValues(dataSetRows);
		
		let combineDataFormat = formatRowValues(combineData);
		//console.log('dataSetRows->',dataSetRows);
		
		const customStyles = {
		  headCells: {
			style: {
			  fontWeight: "bold",
			  fontSize: "16px",
			},
		  },
		  cells: {
			style: {
			  fontSize: "16px",
			},
		  },
		};
		
		/* const conditionalRowStyles = [
		  {
			when: (row) => row.HCPCS === this.state.highlightValue || row.HCPCS?.includes(this.state.highlightValue),
			style: {
			  backgroundColor: "#d1ddff",
			  border: "1px solid #4a85ef",
			  fontWeight: "bold",
			},
		  },
		]; */
		
		const conditionalRowStyles = [
		  {
			when: (row) => {
			  const value = this.state.highlightValue?.toLowerCase() || "";
			  const words = value.split(" ").filter(Boolean);

			  const hcpcs = row.HCPCS?.toLowerCase() || "";

			  return words.length > 0 && words.every(word => hcpcs.includes(word));
			},
			style: {
			  backgroundColor: "#e9efff",
			  //border: "1px solid #4a85ef",
			  //fontWeight: "bold",
			},
		  },
		];
		
		const conditionalRowStyles2 = [
		  {
			when: (row) =>
			  this.state.selectedRow &&
			  this.state.selectedRow.HCPCS === row.HCPCS,
			style: {
			  backgroundColor: "#c8f7c5",
			  //border: "1px solid #28a745",
			  fontWeight: "600",
			},
		  },
		  {
			when: (row) => {
			  // Don't apply search highlight to selected row
			  if (
				this.state.selectedRow &&
				this.state.selectedRow.HCPCS === row.HCPCS
			  ) {
				return false;
			  }

			  const value = this.state.highlightValue?.toLowerCase() || "";
			  const words = value.split(" ").filter(Boolean);
			  const hcpcs = row.HCPCS?.toLowerCase() || "";

			  return words.length > 0 && words.every(word => hcpcs.includes(word));
			},
			style: {
			  backgroundColor: "#e9efff",
			  //border: "1px solid #4a85ef",
			},
		  },
		];
		
		const columns = policyData?.length ? Object.keys(policyData[0]) : [];
		
		/* let filterOption = fData.map(function(val,i) {
			let rural = this.state.Rural;
			
			return (
				<option value={val[i]} key={i}>{val[i]}</option>
			);
		})
		 */
		let filterOption = fData.map((val, i) => {
			let rural = String(this.state.Rural) === "true";
			let optionValue = val[i];
			let isRuralOption = /\s?\(R\)$/.test(optionValue);
			if (rural && !isRuralOption) return null;
			if (!rural && isRuralOption) return null;

			return (
				<option value={optionValue} key={i}>
					{optionValue}
				</option>
			);
		});
		
		let codeOption = policyData.map(function(val,i) {
			return (
				<option value={val.HCPCS} key={i}>{val.HCPCS}</option>
			);
		})
		
		let policyOption = policyData.map(function(val,i) {
			return (
				<option value={val.Policy} key={i}>{val.Policy}</option>
			);
		})
		
		let dataSetOptions = dataSets.map(function(val,i) {
			return (
				<option value={val.DataSetGuid} key={i}>{val.DataSetName}</option>
			);
		})
	
	
		/* let policyDataHtml = Object.entries(HcpcsDetails).map(([key, val], i) => {
		  if (i > 2) {
			return (
			  <div className="code-details2" key={key}>
				<p><b>{key}:</b></p>
				<p>{val}</p>
			  </div>
			);
		  }
		  return null;
		}); */
		
		/* let policyDataHtml = Object.entries(HcpcsDetails).map(([key, val], i) => {
		  if (i > 2) {
			let formattedVal = val;

			// Check if value is numeric
			if (!isNaN(val) && String(val).includes('.')) {
			  formattedVal = Number(val).toFixed(2);
			}
			 
			if(key == 'AL')){
				let rural = String(this.state.Rural) === "true";
				let optionValue = key;
				let isRuralOption = /\s?\(R\)$/.test(optionValue);
				if (rural && !isRuralOption) return null;
				if (!rural && isRuralOption) return null;
			}

			return (
			  <div className="code-details2" key={key}>
				<p><b>{key}:</b></p>
				<p>{formattedVal}</p>
			  </div>
			);
		  }
		  return null;
		}); */
		
		let rural = this.state.Rural;
		let policyLocation = this.state.policyLocation; 

		let policyDataHtml = Object.entries(HcpcsDetails).map(([key, val], i) => {
			let cleanKey = key.trim();

			let formattedVal =
				!isNaN(val) && String(val).includes(".")
					? Number(val).toFixed(2)
					: val;

			// Only apply filter for state codes (AL, AL (R), AR, AR (R)...)
			let isStateCode =
				/^[A-Z]{2}(\s*\(R\))?$/.test(cleanKey);

			if (isStateCode) {
				let isRuralOption = cleanKey.includes("(R)");

				if (rural && !isRuralOption) return null;
				if (!rural && isRuralOption) return null;
			}
			
			if (policyLocation && isStateCode) {
				if (cleanKey !== policyLocation) return null;
			}

			return (
				<div className="code-details2" key={key}>
					<p><b>{cleanKey}:</b></p>
					<p>{formattedVal}</p>
				</div>
			);
		});
		
		//console.log('HcpcsDetails->',HcpcsDetails);
        return(
            <div className="container-fluid">
				<MainHeader builderOption = {this.builderOption}  />
				<div className="content-container">
					<div id="wrapper" className="toggled">
						<div>
							<div className="toggle toggle-btn">
								<a href="#" className="burger js-menu-toggle active" data-toggle="collapse">
									<span></span>
								</a>
							</div>
							<aside className="sidebar">
							 <div className="side-inner align-items-end" >
								<div className="sidebar-content">
									<div className="nav-content">
									  <div className="nav-header">
										<h4 className="page-title">AOPA Coding Pro</h4>
									  </div>

										{/* role === "Administrator" && (
										<div className="admin-panel">
											<h5 className="admin-title">Administrator Tools</h5>
											<div className="form-group">
												<label htmlFor="userData">Update Data</label>
												<select
												  id="userData"
												  className="form-control"
												  name="userData"
												  onChange={this.getValue}
												>
												  <option value="">Please Select</option>
												  <option value="updatePolicy">Update Policy File</option>
												  <option value="updateImage">Update Image</option>
												</select>
											</div>
											{showUpdateImage ? 
												<div className="form-group">
													<label htmlFor="LCode">Select Code</label>
													<select
													  id="LCode"
													  className="form-control"
													  name="LCode"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
											<div className="form-group">
												<label htmlFor="LCode">Manage Users</label>
												<div className="mg-user-btn">
												  <button className="btn btn-default" onClick={this.handleButtonClick2}>Add/Edit Company</button>
												</div>
												<div className="mg-user-btn">
												  <button className="btn btn-default" onClick={this.handleButtonClick3}>Add/Edit Users</button>
												</div>
											</div>
										</div>
										) */}
										
										{ role === "Administrator" && (
										<div className="admin-panel">
											<h5 className="admin-title">Administrator Tools</h5>
											<div className="form-group">
												<label htmlFor="userData">Update Data Set Images</label>
												<select
												  id="userData"
												  className="form-control"
												  name="userData"
												  onChange={this.getValue}
												>
												  <option value="">Please Select</option>
												  <option value="updateImage">Update Image</option>
												</select>
											</div>
											{showUpdateImage ? 
												<div className="form-group">
													<label htmlFor="LCode">Select Code</label>
													<select
													  id="LCode"
													  className="form-control"
													  name="LCode"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
										</div>
										) }
										
										{role === "Administrator" && (
										<div className="admin-panel">
											<div className="left-panel-fun">
												<label htmlFor="userData">Manage Data Sets</label>
												<div className="form-group">
													<select
													  id="adminUserOption"
													  className="form-select"
													  name="adminUserOption"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  <option value="manageDataSets">Manage Data Sets</option>
													</select>
												</div>
											</div>
											{showDataSets ? 
											<div className="left-panel-fun">
												{/* Object.keys(dataSets2).length > 0 && (
												<div className="mg-view-data">
												<button className="btn btn-info" onClick={this.getCombineDataSet}>View Full Data Set</button>
												</div>
												) */}
												<div className="mg-view-data">
												<button className="btn btn-info" onClick={this.viewCombineDataSet}>View Full Data Set</button>
												</div>
												{this.state.showCombinedDataTable ?
												<div className="mg-upload">
												  <button className="btn btn-info" onClick={this.uploadDataSet}>Add a New data subset</button>
												</div>
												:null}
												<h5 className="admin-title">View/Edit Data Subset</h5>
												<div className="form-group">
													<select
													  id="dataSet"
													  className="form-select"
													  name="dataSet"
													  onChange={this.loadDataSet}
													>
													  <option value="">Please Select</option>
													  {dataSetOptions}
													</select>
												</div>
												
												{/* <div className="mg-upload">
												  <button className="btn btn-info" onClick={this.downloadTemplate}>Download Template</button>
												</div> */}
												
												{this.state.selectedSetName && dataSetRows ?
												<div className="mg-find-code">
													<input className="form-control mb-1" type="text" placeholder="Enter HCPCS" value={this.state.searchValue} onChange={this.handleInputChange}
													/>
													{this.state.highlightValue ? 
													<button className="btn btn-info" onClick={this.clearSearch}>Clear</button>
													:
													<button className="btn btn-info" onClick={this.goToRow}>Find</button>
													}
												</div>
												:null}
											</div>
											:null}
											
											
										</div>
										)}
									  
										{(role === "Administrator" || role === "Demo-Admin" || role === "Demo-User" || role === "User") && (
										  <div className="admin-panel">
											<h5 className="admin-title">User Functions</h5>
											<div className="form-group">
											  <select
												id="userPage"
												className="form-select"
												name="userPage"
												onChange={this.getValue}
											  >
												<option value="">Please Select</option>
												<option value="byHcpcs">Search By HCPCS Code</option>
												<option value="compare">Compare Codes</option>
											  </select>
											</div>
											{this.state.userPage1 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode">Select HCPCS Code</label>
													<select
													  id="HcpcsCode"
													  className="form-select"
													  name="HcpcsCode"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
											{/* this.state.userPage1 ?
												<div className="form-group">
													<label htmlFor="policy">Select Policy</label>
													<select
													  id="policy"
													  className="form-control"
													  name="policy"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {policyOption}
													</select>
												</div>
											:null */}
											
											{this.state.userPage1 ?
												<div className="form-group">
													<label>
													  <input className="large-checkbox" name="Rural" type="checkbox" checked={this.state.Rural} onChange={this.getValue} /> &nbsp; Rural
													</label>
													<div>
													<label htmlFor="policyLocation">Select Location</label>
													<select
													  id="policyLocation"
													  className="form-select"
													  name="policyLocation"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {filterOption}
													</select>
													</div>
												</div>
											:null}
											
											{this.state.userPage2 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode1">Select First HCPCS Code</label>
													<select
													  id="HcpcsCode1"
													  className="form-select"
													  name="HcpcsCode1"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null} 
											
											{this.state.userPage2 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode2">Select Second HCPCS Code</label>
													<select
													  id="HcpcsCode2"
													  className="form-select"
													  name="HcpcsCode2"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
										  </div>
										)}
									</div>
								</div>
							  </div>
							</aside>
							
							<div className={'content-wrapper container'} >
								{isHomePage ?
									<div className="home-page">
									<h3 className='page-title'>AOPA Coding Pro</h3>
									<div className="l-code-logo"><img src="/L-logo.png" alt="L-code-Explorer" /></div>
									</div>
								:null}
								
								{this.state.selectedSetName != '' && dataSetRows && !this.state.showCombinedDataTable ?
								<div className="data-set-page first-tb">
									
									<h3 className='page-title'>DataSet - {this.state.selectedSetName} <button type="button" className="btn btn-link iball-icon"> <i className="fa fa-info-circle" aria-hidden="true" onClick={this.dataSetsDetails}></i></button><button className="btn" onClick={() => this.handleEditDataSet(setObject)}><i className="fa fa-edit"></i></button></h3>
									
									<p style={{ float: 'left' }}><b>V-{moment(setObject.ModifiedDate).format('MMDDYYYYHHmmss')}</b></p>
									{this.state.dataSetVersions && this.state.dataSetVersions.length > 0 ? (
									  <div className="select-verion">
									  <select className="form-select"
										value={this.state.selectedVersion || ''}
										onChange={this.handleVersionChange}
									  >
										{this.state.selectedVersion ? 
										<option value="">Current Version</option>
										: <option value="">Select Version</option>
										}

										{this.state.dataSetVersions.map((version, index) => (
										  <option key={index} value={version.Version}>
											V-{version.Version}
										  </option>
										))}
									  </select>
									  {this.state.selectedVersion ?
										<button className="btn btn-primary ms-2" onClick={() => {if (window.confirm('Are you sure you want to revert selected version to Original?')) this.revertDataSet(this.state.selectedVersion)}}>Revert</button>
									  :null}
									   </div>
									) : null}
									
									<div className="data-tb-sec">
									<DataTable
										title=""
										columns={this.getColumns()}
										data={dataSetRows}
										pagination
										paginationPerPage={10}
										paginationRowsPerPageOptions={[10, 25, 50, 100]}
										paginationDefaultPage={currentPage}
										paginationResetDefaultPage={this.state.resetPaginationToggle}
										highlightOnHover
										striped
										responsive
										noDataComponent="No records found"
										customStyles={customStyles}
										conditionalRowStyles={conditionalRowStyles}
									/>
									</div>
									<div className="data-set-bottom">
										<h6>Last File Upload - {moment(setObject.CreatedDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										<h6>Last Edit - {moment(setObject.ModifiedDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										{this.state.selectedSetName && dataSetRows ?
										<div className="mg-download">
											<button className="btn btn-info" onClick={this.downloadLatestData}>Download Latest Version</button>
											&nbsp;
											<button className="btn btn-info" onClick={this.replaceDataSet}>Upload New Version of this Data Set</button>
											&nbsp;
											{/* <div className="show-output-text">
											<label className="showAllSwitch">
												<input type="checkbox" name="showHideCode" onClick={this.showAllCodes2}/>
												<span className="slider round showAllSlide"></span>
											</label> Show Hidden Codes
											</div> */}
											<div className="code-filter">
												<label>
												  <input
													className="large-checkbox"
													type="checkbox"
													checked={codeFilter2 === "all"}
													onChange={() => this.handleCodeFilter2("all")}
												  />
												  Show All
												</label>

												<label>
												  <input
													className="large-checkbox"
													type="checkbox"
													checked={codeFilter2 === "hidden"}
													onChange={() => this.handleCodeFilter2("hidden")}
												  />
												  Show Only Hidden
												</label>

												<label>
												  <input
												    className="large-checkbox"
													type="checkbox"
													checked={codeFilter2 === "nonHidden"}
													onChange={() => this.handleCodeFilter2("nonHidden")}
												  />
												  Show Only Non-Hidden
												</label>
											</div>
										</div>
										:null}
									</div>
								</div>
								:null}
								
								{this.state.showCombinedDataTable && combineData ?
								<div className="data-set-page combined-data">
									<h3 className='page-title'>Combined Data</h3>
									<div className="combined-data-tb">
									<DataTable
										title=""
										columns={this.getColumns2()}
										data={combineDataFormat}
										pagination
										paginationPerPage={10}
										paginationRowsPerPageOptions={[10, 25, 50, 100]}
										paginationDefaultPage={currentPage}
										highlightOnHover
										striped
										responsive
										noDataComponent="No records found"
										customStyles={customStyles}
										conditionalRowStyles={conditionalRowStyles2}
										onRowClicked={this.handleRowClick}
									/>
									</div>
									{Object.keys(combineAllData).length > 0 && (
									<div className="data-set-bottom">
										<h6>Last Updated - {moment(this.state.combinedLastDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										<div className="mg-download">
											<button className="btn btn-info" onClick={this.downloadCombinedData}>Download Full Data Set</button>
											&nbsp;
											{this.state.showColumn ?
											<button className="btn btn-success" onClick={this.hideShowColumn}>Hide/Show Column</button>
											:
											<button className="btn btn-info" onClick={this.hideShowColumn}>Hide/Show Column</button>
											}
											&nbsp;
											
											{/* <div className="show-output-text">
											<label className="showAllSwitch">
												<input type="checkbox" name="showHide" onClick={this.showAllCodes}/>
												<span className="slider round showAllSlide"></span>
											</label> Show Hidden Codes
											</div> */}
											
											<div className="code-filter">
												<label>
												  <input
													className="large-checkbox"
													type="checkbox"
													checked={codeFilter === "all"}
													onChange={() => this.handleCodeFilter("all")}
												  />
												  Show All
												</label>

												<label>
												  <input
													className="large-checkbox"
													type="checkbox"
													checked={codeFilter === "hidden"}
													onChange={() => this.handleCodeFilter("hidden")}
												  />
												  Show Only Hidden
												</label>

												<label>
												  <input
												    className="large-checkbox"
													type="checkbox"
													checked={codeFilter === "nonHidden"}
													onChange={() => this.handleCodeFilter("nonHidden")}
												  />
												  Show Only Non-Hidden
												</label>
											</div>
											
											<div className="add-edit-btn">
												<button className="btn btn-info" onClick={this.uploadCodeData} >Add New Data Rows w/ Template</button>
												<button className="btn btn-info" onClick={this.handleNewCode}>Add New Code Manually</button>
												{this.state.selectedRow ?
												<button className="btn btn-info" onClick={this.handleEditCode}>Edit Single Code</button>
												:null}
											</div>
											
										</div>
									</div>
									)}
								</div>
								:null}

								{this.state.editCompany ?
								<div className="l-code-logo2"><img src="/cm.png" alt="L-code-Explorer" /></div>
								:null}
								{this.state.editUser ?
								<div className="l-code-logo3"><img src="/us.png" alt="L-code-Explorer" /></div>
								:null}
								{showUpdatePolicy ?
								<div className="page-content-area">
									<div className="page-header">
										<div className="mg-title"><h5>Update Policy File</h5></div>
										<div className="mg-upload">
										  <input type="file" ref={this.fileInputRef} style={{ display: "none" }}/>
										  <button className="btn btn-info" onClick={this.handleButtonClickb}>Upload New File</button>
										</div>
										<div className="mg-last-date">
										Last Updated : 02/11/2026 01:30:22
										</div>
										
									</div>
									<p></p>
									<div className="policy-table">
									<table className="table table-bordered user-table table-sm"> 
										<thead>
										  <tr>
											{columns.map((col) => (
											  <th key={col}>{col}</th>
											))}
										  </tr>
										</thead>
										<tbody>
											{policyData.map((row, index) => (
												<tr key={index}>
												  {columns.map((col) => (
													<td key={col}>
													  {typeof row[col] === "object" ? JSON.stringify(row[col]) : row[col]}
													</td>
												  ))}
												</tr>
											))}
										</tbody>
									  </table>
									  </div>
								</div>
								:null}
								{showUpdateImage && LCode ? 
								<div className="page-content-area">
									<div className="page-header">
										<div className="mg-title"><h5>Update Image</h5></div>	
									</div>
									<p></p>
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-4">
												
												{ (this.state[LCode] || []).length > 0 ? (

												<div id={`carousel-${LCode}`} className="carousel slide">

													<div className="carousel-indicators">
														{(this.state[LCode] || []).map((img,index)=>(
															<button
																key={index}
																type="button"
																data-bs-target={`#carousel-${LCode}`}
																data-bs-slide-to={index}
																className={index===0?"active":""}
															/>
														))}
													</div>

													<div className="carousel-inner">
														{(this.state[LCode] || []).map((img,index)=>(
															<div
																key={index}
																className={`carousel-item ${index===0?"active":""}`}
															>
																<img
																	src={img.url}
																	className="d-block w-100"
																	alt={img.name}
																/>
															</div>
														))}
													</div>

													<button
														className="carousel-control-prev"
														type="button"
														data-bs-target={`#carousel-${LCode}`}
														data-bs-slide="prev"
													>
														<span className="carousel-control-prev-icon"></span>
													</button>

													<button
														className="carousel-control-next"
														type="button"
														data-bs-target={`#carousel-${LCode}`}
														data-bs-slide="next"
													>
														<span className="carousel-control-next-icon"></span>
													</button>

												</div>

												) : (

													<div className="code-img">
														<img
															src={`${ApiUrl}/images/${LCode}.jpg`}
															alt={LCode}
															onError={(e)=>{
																e.target.onerror=null;
																e.target.src=`${ApiUrl}/images/nopic.jpg`;
															}}
														/>
													</div>

													)
												}
												
												<div className="mg-upload-2">
												  <input type="file" ref={this.fileInputRef} style={{ display: "none" }} onChange={this.handleFileChange}/>
												  <button className="btn btn-info" onClick={this.handleButtonClick}>
													Change Image
												  </button>
												</div>
												<div className="mg-upload-2">
												  <input
													type="file"
													ref={this.fileInputRefMulti}
													style={{ display: "none" }}
													multiple
													accept="image/*"
													onChange={this.handleMultipleImages}
												  />
												  <button className="btn btn-info" onClick={this.handleButtonClickMulti}>
													Add Additional Images
												  </button>
												</div>
											</div>
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-7">
											  <div className="code-details"><p><b>Policy: </b></p><p>{LCodeDetails['Policy']}</p></div>
											  <div className="code-details"><p><b>HCPCS: </b></p><p>{LCodeDetails['HCPCS']}</p></div>
											  <div className="code-details"><p><b>HCPCS Description: </b></p><p>{LCodeDetails['HCPCS Descriptor']}</p></div>
											  <div className="code-details"><p><b>Policy-Coverage Criteria: </b></p><p>{LCodeDetails['Policy-Coverage Criteria']}</p></div>
											</div>
										</div>
									</div>
								</div>
								:null}
								
								{this.state.userPage1 && HcpcsCode && HcpcsDetails ? 
								
								<div className="page-content-area">
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-4 aa">
												{ (this.state[HcpcsCode] || []).length > 0 ? (

												<div id={`carousel-${HcpcsCode}`} className="carousel slide">

													<div className="carousel-indicators">
														{(this.state[HcpcsCode] || []).map((img,index)=>(
															<button
																key={index}
																type="button"
																data-bs-target={`#carousel-${HcpcsCode}`}
																data-bs-slide-to={index}
																className={index===0?"active":""}
															/>
														))}
													</div>

													<div className="carousel-inner">
														{(this.state[HcpcsCode] || []).map((img,index)=>(
															<div
																key={index}
																className={`carousel-item ${index===0?"active":""}`}
															>
																<img
																	src={img.url}
																	className="d-block w-100"
																	alt={img.name}
																/>
															</div>
														))}
													</div>

													<button
														className="carousel-control-prev"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode}`}
														data-bs-slide="prev"
													>
														<span className="carousel-control-prev-icon"></span>
													</button>

													<button
														className="carousel-control-next"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode}`}
														data-bs-slide="next"
													>
														<span className="carousel-control-next-icon"></span>
													</button>

												</div>

												) : (

													<div className="code-img">
														<img
															src={`${ApiUrl}/images/${HcpcsCode}.jpg`}
															alt={HcpcsCode}
															onError={(e)=>{
																e.target.onerror=null;
																e.target.src=`${ApiUrl}/images/nopic.jpg`;
															}}
														/>
													</div>

												)
												}

												<div className="code-details2">
													<p><b>Policy:</b></p>
													<p>{HcpcsDetails['Policy']}</p>
												</div>

												<div className="code-details2">
													<p><b>HCPCS:</b></p>
													<p>{HcpcsDetails['HCPCS']}</p>
												</div>

												<div className="code-details2">
													<p><b>HCPCS Description:</b></p>
													<p>{HcpcsDetails['HCPCS Descriptor']}</p>
												</div>
											</div>
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-7">
											{policyDataHtml}
											</div>
										</div>
									</div>
								</div>
								:null}
								
								{this.state.userPage2 && HcpcsCode1 && HcpcsCode2 ? 
								<div className="page-content-area">
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-4 bb">
												{ (this.state[HcpcsCode1] || []).length > 0 ? (

												<div id={`carousel-${HcpcsCode1}`} className="carousel slide">

													<div className="carousel-indicators">
														{(this.state[HcpcsCode1] || []).map((img,index)=>(
															<button
																key={index}
																type="button"
																data-bs-target={`#carousel-${HcpcsCode1}`}
																data-bs-slide-to={index}
																className={index===0?"active":""}
															/>
														))}
													</div>

													<div className="carousel-inner">
														{(this.state[HcpcsCode1] || []).map((img,index)=>(
															<div
																key={index}
																className={`carousel-item ${index===0?"active":""}`}
															>
																<img
																	src={img.url}
																	className="d-block w-100"
																	alt={img.name}
																/>
															</div>
														))}
													</div>

													<button
														className="carousel-control-prev"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode1}`}
														data-bs-slide="prev"
													>
														<span className="carousel-control-prev-icon"></span>
													</button>

													<button
														className="carousel-control-next"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode1}`}
														data-bs-slide="next"
													>
														<span className="carousel-control-next-icon"></span>
													</button>

												</div>

												) : (

													<div className="code-img">
														<img
															src={`${ApiUrl}/images/${HcpcsCode1}.jpg`}
															alt={HcpcsCode1}
															onError={(e)=>{
																e.target.onerror=null;
																e.target.src=`${ApiUrl}/images/nopic.jpg`;
															}}
														/>
													</div>

													)
												} 
												
												<div className="code-details2"><p><h5>Policy: </h5></p><p>{HcpcsDetails1['Policy']}</p></div>
												<div className="code-details2"><p><h5>HCPCS: </h5></p><p>{HcpcsDetails1['HCPCS']}</p></div>
												<div className="code-details2"><p><h5>HCPCS Description: </h5></p><p>{HcpcsDetails1['HCPCS Descriptor']}</p></div>
												<div className="code-details2"><p><h5>Ceiling: </h5></p><p>{HcpcsDetails1['Ceiling']}</p></div>
											</div>
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-4">	
												{ (this.state[HcpcsCode2] || []).length > 0 ? (

												<div id={`carousel-${HcpcsCode2}`} className="carousel slide">

													<div className="carousel-indicators">
														{(this.state[HcpcsCode2] || []).map((img,index)=>(
															<button
																key={index}
																type="button"
																data-bs-target={`#carousel-${HcpcsCode2}`}
																data-bs-slide-to={index}
																className={index===0?"active":""}
															/>
														))}
													</div>

													<div className="carousel-inner">
														{(this.state[HcpcsCode2] || []).map((img,index)=>(
															<div
																key={index}
																className={`carousel-item ${index===0?"active":""}`}
															>
																<img
																	src={img.url}
																	className="d-block w-100"
																	alt={img.name}
																/>
															</div>
														))}
													</div>

													<button
														className="carousel-control-prev"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode2}`}
														data-bs-slide="prev"
													>
														<span className="carousel-control-prev-icon"></span>
													</button>

													<button
														className="carousel-control-next"
														type="button"
														data-bs-target={`#carousel-${HcpcsCode2}`}
														data-bs-slide="next"
													>
														<span className="carousel-control-next-icon"></span>
													</button>

												</div>

												) : (

													<div className="code-img">
														<img
															src={`${ApiUrl}/images/${HcpcsCode2}.jpg`}
															alt={HcpcsCode2}
															onError={(e)=>{
																e.target.onerror=null;
																e.target.src=`${ApiUrl}/images/nopic.jpg`;
															}}
														/>
													</div>

													)
												}
												
												<div className="code-details2"><p><h5>Policy: </h5></p><p>{HcpcsDetails2['Policy']}</p></div>
												<div className="code-details2"><p><h5>HCPCS: </h5></p><p>{HcpcsDetails2['HCPCS']}</p></div>
												<div className="code-details2"><p><h5>HCPCS Description: </h5></p><p>{HcpcsDetails2['HCPCS Descriptor']}</p></div>
												<div className="code-details2"><p><h5>Ceiling: </h5></p><p>{HcpcsDetails2['Ceiling']}</p></div>
											</div>
										</div>
									</div>
								</div>
								:null}
								
								<div className="modal fade" id="showDuplicateModal" tabIndex="-1">
									<div className="modal-dialog modal-lg">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">Duplicate HCPCS Codes</h5>
											</div>

											<div className="modal-body">
												<textarea
													className="form-control"
													rows="8"
													readOnly
													value={this.state.duplicateCodes.join(", ")}
												/>
											</div>

											<div className="modal-footer">
												<button
													className="btn btn-primary"
													onClick={() => {
														navigator.clipboard.writeText(
															this.state.duplicateCodes.join(", ")
														);
														alert("Copied to clipboard.");
													}}
												>
													Copy
												</button>

												<button
													className="btn btn-secondary"
													onClick={() => this.setState({ showDuplicateModal: false })}
												>
													Close
												</button>
											</div>
										</div>
									</div>
								</div>
								
								
								<div className="modal fade" id="addNewCode" tabIndex="-1">
								  <div className="modal-dialog">
									<div className="modal-content">
									  <div className="modal-header">
										<h5 className="modal-title">Add New Code</h5>
										<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
									  </div>
									  <div className="modal-body">
										<DebounceInput
											debounceTimeout={4000}
											type="text"
											className="form-control"
											name={'NewCode'}
											onChange={this.getValue}
										/>
									  </div>
									  <div className="modal-footer">
										<button type="button" className="btn btn-primary" onClick={this.addNewHcpcsCode}>Save</button>
										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
									  </div>
									</div>
								  </div>
								</div>
								
								<div className="modal fade" id="editCodePopup" tabIndex="-1">
								  <div className="modal-dialog">
									<div className="modal-content">
									  <div className="modal-header">
										<h5 className="modal-title">Edit HCPCS Code - {this.state.selectedRow ? this.state.selectedRow['HCPCS'] : null}</h5>
										<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
									  </div>
									  <div className="modal-body">
										<div className="select-code-section">
											<label>Select the section to add/edit details</label>
											<div className="select-code-edit">
											{this.state.selectedRow &&
													Object.keys(this.state.selectedRow).map((key) => {
													if (key === "HCPCS" || key === "updated_at" || key === "__rowNum__") return null;

													return (
													  <button onClick={this.selectKeyToEdit} className={this.state.selectedKeyEdit == key ? "field-btn selected-key" : "field-btn"} type="button" value={key}>{key.replace(/([A-Z])/g, " $1").trim()}</button>
													);
												})}
											</div>
										</div>

										<div className="edit-code-section">
										{this.state.selectedRow &&
											Object.keys(this.state.selectedRow).map((key) => {
											if (key != this.state.selectedKeyEdit || key === "HCPCS" || key === "updated_at" || key === "__rowNum__") return null;
											return (
											  <div className="op-input" key={key}>
												<label>{key.replace(/([A-Z])/g, " $1").trim()}: </label>
												<DebounceInput
												  debounceTimeout={4000}
												  element="textarea"
												  rows={5}
												  className="form-control"
												  value={this.state.selectedRow[key] || ""}
												  name={key}
												  onChange={this.getValue}
												/>
											  </div>
											);
										})}
										</div>
									  </div>

									  {/* Footer */}
									  <div className="modal-footer">
										<button type="button" className="btn btn-primary" onClick={this.editCodeDataUpdate}>
										  Update
										</button>
										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
										  Close
										</button>
									  </div>

									</div>
								  </div>
								</div>
								
								<div className="modal fade" id="editRowPopup" tabIndex="-1">
								  <div className="modal-dialog">
									<div className="modal-content">
									  <div className="modal-header">
										<h5 className="modal-title">Edit {this.state.selectedSetName}</h5>
										<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
									  </div>
									  <div className="modal-body">
										{this.state.editRow &&
										  Object.keys(this.state.editRow).map((key) => {
										if (key === "HCPCS" || key === "updated_at" || key === "__rowNum__") return null;

											return (
											  <div className="op-input" key={key}>
												<label>{key.replace(/([A-Z])/g, " $1").trim()}: </label>
												<DebounceInput
												  debounceTimeout={4000}
												  type="text"
												  className="form-control"
												  value={this.state.editRow[key]}
												  name={key}
												  onChange={this.getValue}
												/>
											  </div>
											);
										  })}
									  </div>
									  <div className="modal-footer">
										<button type="button" className="btn btn-primary" onClick={this.editRowUpdate}>
										  Update
										</button>
										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
										  Close
										</button>
									  </div>

									</div>
								  </div>
								</div>
								
								<div className="modal fade" id={"uploadCodeDataPopup"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												To add new Code Template that has full rows of new data, download the template of all headers, then add additional data, then upload the file here, This will add new code row to the end of the Full Data Set.
											</div>
											<div className="modal-footer">
												<button className="btn btn-info" onClick={this.downloadCombinedDataHeader} >Download New Code Template</button>
												<input type="file" accept=".xlsx, .xls" ref={(input) => (this.fileInput4 = input)} style={{ display: "none" }} onChange={this.handleFileUploadRowData} />
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet4} data-bs-dismiss="modal">Upload File</button>
													{/* <button type="button" className="btn btn-primary" onClick={this.uploadDataSet3} data-bs-dismiss="modal">Replace</button> */}
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"uploadSetPopup"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												To add new data elements and new columns to the Full Data Set, download the template of Active HCPCS codes, then add additional data, then upload the file here, This will add new data columns to the end of the Full Data Set.
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-info" onClick={this.downloadTemplate}>Download Template</button>
												<input type="file" accept=".xlsx, .xls" ref={(input) => (this.fileInput = input)} style={{ display: "none" }} onChange={this.handleFileUpload} />
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet2} data-bs-dismiss="modal">Upload File</button>
													{/* <button type="button" className="btn btn-primary" onClick={this.uploadDataSet3} data-bs-dismiss="modal">Replace</button> */}
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"replaceSetPopup"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												This function will completely replace the current data set with the new data set that you are uploading. Be careful to maintain original files as backups.
											</div>
											<div className="modal-footer">
												<input type="file" accept=".xlsx, .xls" ref={(input) => (this.fileInput2 = input)} style={{ display: "none" }} onChange={this.handleFileUpload2} />
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet3} data-bs-dismiss="modal">Select File</button>
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"DataSetsDetails"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-body">
												<div className={"data-set-name"}>
													<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
													<div className={"data-set-del"}><b>DataSet Name : </b><b>{setObject.DataSetName}</b></div>
													<div className={"data-set-del"}><b>File Prefix : </b>{setObject.FilePrefix}</div>
													<div className={"data-set-del"}><b>Description : </b>{setObject.Description}</div>
													<div className="data-set-del">
													  <b>Notes : </b>
													  {(setObject.DataSetNotes || '').split('\n').map((line, index) => (
														<div key={index}>{line}</div>
													  ))}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"DataSetsHeaderDetails"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-body">
												<div className={"data-set-name"}>
													<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
													<div className="data-set-del header-des">
													  <p><b>Header Name : {this.state.headerName}</b></p>
													  <b>Description : </b>
													  {this.state.headerDescription}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"DataSetsEditDetails"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<div className="header-dec-a">Data Set Details</div>
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												
												<div className="form-group">
													<label>DataSet Name:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="DataSetName" onChange={this.getValue} value={this.state.DataSetName ? this.state.DataSetName : setObject.DataSetName} />
												</div>
												
												<div className="form-group">
													<label>File Prefix:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="FilePrefix" onChange={this.getValue} value={this.state.FilePrefix ? this.state.FilePrefix : setObject.FilePrefix} />
												</div>
												
												<div className="form-group">
													<label>Description:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="Description" onChange={this.getValue} value={this.state.Description ? this.state.Description : setObject.Description} />
												</div>
												
												<div className="form-group">
													<label>Note:</label>
													<DebounceInput element="textarea" rows="2" debounceTimeout={4000} className="form-control" name='DataSetNote' onChange={this.getValue} />
												</div>
												<div className="header-dec-h">Headers Description</div>
												{this.state.setObject.DataSetRows &&
													Object.keys(this.state.setObject.DataSetRows[0]).map((key) => {
													if (key === "HCPCS" || key === "updated_at") return null;

													return (
													  <div className="form-group" key={key}>
														<label>{key.replace(/([A-Z])/g, " $1").trim()}: </label>

														<DebounceInput
														  debounceTimeout={4000}
														  type="text"
														  className="form-control"
														  value={this.state['HDes' + key] ?? setObject['HDes' + key] ?? ''}
														  name={'HDes' + key}
														  onChange={this.getValue}
														/>
													  </div>
													);
												})}
												<div className="form-group">
													<label>History:</label>
													<DebounceInput type="text" debounceTimeout={4000} className="form-control" name='HDesHistory' onChange={this.getValue} />
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSetDetails} data-bs-dismiss="modal">Save</button>
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>

								
							</div>
						</div>
					</div>
				</div>
            </div>
        );
    }
}

export default AopaCode;